// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"loginContainer_loginContainer__2wSqr","mainText":"loginContainer_mainText__1j2JF","card":"loginContainer_card__3z1kc"};